import { useCallback } from 'react';

import { UserPayload } from 'api/profile';
import AddUser from '../components/AddUser';

const AddUserContainer = () => {
  const isAdmin = sessionStorage.getItem('isAdmin')?.toString() != 'true' ? true : false;
  const handleSubmit = useCallback(async (_payload: UserPayload) => {
    // payload.isActive = 1;
    // payload.name = payload.firstName + ' ' + payload.lastName;
    // adduserList(payload).then((_res) => {
    //   //message.success('Success');
    // });
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Add User</h2>
              <div className="submission-htmlForm">
                <AddUser onSubmit={handleSubmit} isAdmin={isAdmin} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUserContainer;
